/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment400,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment401,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReversePayment.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidReversePayment } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentParcelsParcelidReversePayment.ts";

export const postApiV1IndividualpaymentParcelsParcelidReversePaymentMutationKey =
  () =>
    [
      { url: "/api/v1/individualpayment/parcels/:parcelId/reverse-payment" },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidReversePaymentMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidReversePaymentMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidReversePaymentMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment400
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment401
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams["parcelId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId }) => {
      return postApiV1IndividualpaymentParcelsParcelidReversePayment(
        parcelId,
        config,
      );
    },
  });
}

/**
 * @description Parcela paga volta a pendente, com data/valor pago limpos e observação de estorno. Migrado do legado IndividualPayment/ReversePayment. **(Requer Authorization para autenticação)**
 * @summary Estorno lógico do pagamento (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/reverse-payment}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidReversePayment<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidReversePayment400
        | PostApiV1IndividualpaymentParcelsParcelidReversePayment401
        | PostApiV1IndividualpaymentParcelsParcelidReversePayment500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams["parcelId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidReversePaymentMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidReversePaymentMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidReversePayment400
        | PostApiV1IndividualpaymentParcelsParcelidReversePayment401
        | PostApiV1IndividualpaymentParcelsParcelidReversePayment500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams["parcelId"];
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment400
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment401
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams["parcelId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment400
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment401
      | PostApiV1IndividualpaymentParcelsParcelidReversePayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams["parcelId"];
    },
    TContext
  >;
}
